import user from './user'
import mobile from './mobile'
import message from './message'
import aiConfig from './aiConfig'
import agent from './agent'
import history from './history'
import resources from './resources'
import channel from './channel'
import audio from './audio'
import voice from './voice'
import ipImage from './ipImage'
export default {
    user,
    mobile,
    message,
    aiConfig,
    agent,
    history,
    resources,
    channel,
    audio,
    voice,
    ipImage,
}